export const validateShiftManager = ({
  shiftManager,
  shiftManagers,
  sections,
}) => {
  const errors = {};
  const sectionCodes = sections.reduce((acc, { sectionCode }) => {
    acc[sectionCode] = true;
    return acc;
  }, {});

  shiftManager.sections.forEach(({ dayOfWeek, sectionCode }) => {
    if (!sectionCode) return;
    else if (!sectionCodes[sectionCode]) {
      errors[`${dayOfWeek}-sectionCode`] = "Section does not exist.";
      return;
    }
    const conflictShiftManager = shiftManagers.find(
      ({ shiftManagerCode, sections }) =>
        shiftManagerCode !== shiftManager.shiftManagerCode &&
        !!sections.find(
          (section) =>
            section.dayOfWeek === dayOfWeek &&
            section.sectionCode === sectionCode
        )
    );
    if (conflictShiftManager)
      errors[
        `${dayOfWeek}-sectionCode`
      ] = `Section already in use by ${conflictShiftManager.shiftManagerCode} - ${conflictShiftManager.shiftManagerName}.`;
  });

  return errors;
};
